import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import PayProvidersView from '../views/PayProvidersView.vue'
import ProviderView from '../views/ProviderView.vue'
import AmountView from '../views/AmountView.vue'
import DenominationsView from '../views/DenominationsView.vue'
import PayView from '../views/PayView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/groups/:groupId',
    name: 'groups',
    component: PayProvidersView,
    meta: {
      watchParam: 'groupId'
    }
  },
  {
    path: '/provider/:providerId',
    name: 'provider',
    component: ProviderView
  },
  {
    path: '/denominations/',
    name: 'denominations',
    component: DenominationsView
  },
  {
    path: '/amount/',
    name: 'amount',
    component: AmountView
  },
  {
    path: '/pay/',
    name: 'pay',
    component: PayView,
    props: {
      phone: String,
      amount: String,
      provider: Object
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
